import CrudReducer from './crudReducer';

const cr = new CrudReducer('todo_item');

const reducer = cr.Reducer;

export default reducer;
